import BaseService from './Base.Service';

class ContractValueInputService extends BaseService {
  constructor() {
    super('contract-value-inputs');
  }

  /**
   * Submete um valor variável
   * @param {number} contractId - ID do contrato
   * @param {number} referenceMonth - Mês de referência (1-12)
   * @param {number} referenceYear - Ano de referência
   * @param {number} value - Valor
   * @param {string} notes - Observações opcionais
   * @returns {Promise}
   */
  async submitValue(contractId, referenceMonth, referenceYear, value, notes = null) {
    try {
      const data = {
        contract_id: contractId,
        reference_month: referenceMonth,
        reference_year: referenceYear,
        value: parseFloat(value),
        notes,
      };

      const response = await this.conn.axios.post(this.path, data);
      return response.data;
    } catch (err) {
      let errorMsg = err?.response?.data?.msg || err?.message || 'Erro ao submeter valor';
      // Remove o prefixo "Error: " se existir
      errorMsg = errorMsg.replace(/^Error:\s*/, '');
      
      return {
        error: true,
        msg: errorMsg,
        status: err?.response?.status || 400,
        data: err?.response?.data
      };
    }
  }

  /**
   * Aprova um valor variável
   * @param {number} id - ID do input
   * @returns {Promise}
   */
  async approve(id) {
    try {
      const { data } = await this.conn.axios.put(`${this.path}/${id}/approve`, {});
      return data;
    } catch (err) {
      return this.sendError('Erro ao aprovar valor', 400, err);
    }
  }

  /**
   * Rejeita um valor variável
   * @param {number} id - ID do input
   * @param {string} reason - Motivo da rejeição
   * @returns {Promise}
   */
  async reject(id, reason) {
    try {
      const { data } = await this.conn.axios.put(`${this.path}/${id}/reject`, {
        rejection_reason: reason,
      });
      return data;
    } catch (err) {
      return this.sendError('Erro ao rejeitar valor', 400, err);
    }
  }

  /**
   * Lista inputs pendentes de aprovação
   * @param {string} status - Filtro por status (PENDING, APPROVED, REJECTED)
   * @param {number} contractId - Filtro por contrato
   * @returns {Promise}
   */
  async listPending(status = 'PENDING', contractId = null) {
    try {
      let url = `${this.path}?`;
      const params = [];
      if (status) params.push(`status=${status}`);
      if (contractId) params.push(`contract_id=${contractId}`);
      url += params.join('&');

      const { data } = await this.conn.axios.get(url);
      return data;
    } catch (err) {
      return this.sendError('Erro ao listar inputs', 400, err);
    }
  }
  /**
   * Retorna dados para template de importação em lote
   * @param {number} month - Mês de referência
   * @param {number} year - Ano de referência
   * @returns {Promise}
   */
  async getTemplate(month, year) {
    try {
      const { data } = await this.conn.axios.get(`${this.path}/template?month=${month}&year=${year}`);
      return data;
    } catch (err) {
      return this.sendError('Erro ao buscar template', 400, err);
    }
  }

  /**
   * Retorna contagem de contratos variáveis pendentes de valor
   * @param {number} month - Mês de referência
   * @param {number} year - Ano de referência
   * @returns {Promise}
   */
  async getPendingCount(month, year) {
    try {
      const { data } = await this.conn.axios.get(`${this.path}/pending-count?month=${month}&year=${year}`);
      return data;
    } catch (err) {
      return this.sendError('Erro ao buscar contagem', 400, err);
    }
  }

  /**
   * Importação em lote de valores variáveis
   * @param {Array} items - Array de { contract_id, document, value }
   * @param {number} referenceMonth - Mês de referência
   * @param {number} referenceYear - Ano de referência
   * @returns {Promise}
   */
  async batchSubmitValues(items, referenceMonth, referenceYear) {
    try {
      const response = await this.conn.axios.post(`${this.path}/batch`, {
        reference_month: referenceMonth,
        reference_year: referenceYear,
        items,
      });
      return response.data;
    } catch (err) {
      let errorMsg = err?.response?.data?.msg || err?.message || 'Erro ao importar valores';
      errorMsg = errorMsg.replace(/^Error:\s*/, '');
      return {
        error: true,
        msg: errorMsg,
      };
    }
  }
}

export default ContractValueInputService;
